import * as UserApi from '@/api/Permission'

export default function useChat() {
  const create_manager = async (payload) => {
    const res = await UserApi.create_manager(payload)
    return res
  }
  const edit_manager = async (payload) => {
    const res = await UserApi.edit_manager(payload)
    return res
  }
  const get_manager_list = async (payload) => {
    const res = await UserApi.get_manager_list(payload)
    return res
  }
  const remove_manager = async (payload) => {
    const res = await UserApi.remove_manager(payload)
    return res
  }
  const create_group = async (payload) => {
    const res = await UserApi.create_group(payload)
    return res
  }
  const edit_group = async (payload) => {
    const res = await UserApi.edit_group(payload)
    return res
  }
  const get_group_list = async (payload) => {
    const res = await UserApi.get_group_list(payload)
    return res
  }
  const remove_group = async (payload) => {
    const res = await UserApi.remove_group(payload)
    return res
  }
  const get_group_info = async (payload) => {
    const res = await UserApi.get_group_info(payload)
    return res
  }

  const update_session_last = async (payload)=>{
    const res = await UserApi.update_session_last(payload);
    return res;
  }

  return {
    remove_group,
    get_group_list,
    edit_group,
    create_group,
    remove_manager,
    get_manager_list,
    edit_manager,
    create_manager,
    get_group_info,
    update_session_last,
  }
}
